import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Base API configuration
export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api', // Use relative URL to work in both dev and prod
    credentials: 'include', // Include cookies for authentication
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['Auth', 'UserNodes', 'MapNodes'],
  endpoints: () => ({}), // Endpoints will be injected from other slices
});

